import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private _platformId = inject(PLATFORM_ID);
  
  public setItem<T>(key: string, value: T): void {
    if (typeof window !== 'undefined') {
      try {
        const replacer = (_key: string, val: any) => {
          // Verifica si es un Date real
          if (val instanceof Date) {
            return this._toLocalISOString(val);
          }

          // Verifica si es string ISO y parece fecha
          if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z)?$/.test(val)) {
            const d = new Date(val);
            if (!isNaN(d.getTime())) {
              return this._toLocalISOString(d);
            }
          }

          return val;
        };

        const item = JSON.stringify(value, replacer);
        sessionStorage.setItem(key, item);
      } catch (error) {
        console.error('Error saving to sessionStorage', error);
      }
    }
  }

  public getItem<T>(key: string): T | null {
    if (typeof window !== 'undefined') {
      try {
        const item = sessionStorage.getItem(key);
        const reviver = (_key: string, val: any) => {
          // Si es un string con formato ISO, lo parseamos a Date
          if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(val)) {
            const parsedDate = new Date(val);
            if (!isNaN(parsedDate.getTime())) {
              return parsedDate;
            }
          }
          return val;
        };

        return item ? (JSON.parse(item, reviver) as T) : null;
      } catch (error) {
        console.error('Error reading from sessionStorage', error);
        return null;
      }
    }
    return null;
  }

  public removeItem(key: string): void {
    if (typeof window !== 'undefined') {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {
        console.error('Error removing from sessionStorage', error);
      }
    }
  }
  
  public removeAll(): void {
    if(isPlatformBrowser(this._platformId)) {
      try {
        sessionStorage.clear();
      } catch (error) {
        console.error('Error clearing sessionStorage', error);
      }
    }
  }
  
  private _toLocalISOString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }
}
